var render, staticRenderFns
import script from "./VideoPauseMixin.vue?vue&type=script&lang=js&"
export * from "./VideoPauseMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fc65b1a')) {
      api.createRecord('2fc65b1a', component.options)
    } else {
      api.reload('2fc65b1a', component.options)
    }
    
  }
}
component.options.__file = "src/components/Room/Camstudy/mixins/VideoPauseMixin.vue"
export default component.exports